import { Volume2, VolumeX, Plus, RotateCcw } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Param } from "@/components/editor/Section";
import { audOf, addPt, envDb } from "@/lib/clipAudio";

export const ClipAudioControls = ({ clip, lt, onPatch }) => {
  const a = audOf(clip);
  const set = (patch) => onPatch({ aud: { ...a, ...patch } });
  const maxFade = Math.min(10, +(clip.len / 2).toFixed(2));
  return (
    <div className="mt-3 rounded-md border border-[#FFB800]/30 bg-[#FFB800]/5 p-2.5" data-testid="clip-audio">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] uppercase font-mono-ui tracking-wider text-[#FFB800] flex items-center gap-1.5">
          {a.mute ? <VolumeX className="w-3 h-3" /> : <Volume2 className="w-3 h-3" />}Clip audio
        </span>
        <label className="flex items-center gap-1.5 text-[10px] text-slate-400">Mute<Switch checked={a.mute} onCheckedChange={(mute) => set({ mute })} data-testid="clip-audio-mute" /></label>
      </div>
      <Param label="Clip volume" value={a.gain} min={-60} max={12} step={0.5} unit=" dB" onChange={(gain) => set({ gain })} testId="clip-audio-gain" />
      <Param label="Fade in" value={Math.min(a.fade_in, maxFade)} min={0} max={maxFade} step={0.05} unit="s" onChange={(fade_in) => set({ fade_in })} testId="clip-audio-fade-in" />
      <Param label="Fade out" value={Math.min(a.fade_out, maxFade)} min={0} max={maxFade} step={0.05} unit="s" onChange={(fade_out) => set({ fade_out })} testId="clip-audio-fade-out" />
      <div className="flex items-center justify-between mt-2">
        <span className="font-mono-ui text-[10px] text-slate-400" data-testid="clip-audio-point-count">{a.pts.length} VOLUME POINT{a.pts.length === 1 ? "" : "S"}</span>
        <div className="flex gap-1">
          <button onClick={() => onPatch({ aud: addPt(a, lt, +envDb(a.pts, lt).toFixed(1)) })} data-testid="clip-audio-add-point"
            className="flex items-center gap-1 text-[10px] px-2 py-1 rounded bg-[#0B0C10] border border-[#2A2E3D] text-slate-300 hover:border-[#FFB800]"><Plus className="w-3 h-3" />Point at playhead</button>
          <button onClick={() => set({ pts: [] })} disabled={!a.pts.length} data-testid="clip-audio-reset-points" title="Remove all volume points"
            className="px-2 py-1 rounded bg-[#0B0C10] border border-[#2A2E3D] text-slate-400 hover:text-white disabled:opacity-30"><RotateCcw className="w-3 h-3" /></button>
        </div>
      </div>
      <p className="text-[10px] text-slate-500 mt-2">On the V1 clip: click the gold volume line to add a point, drag points up/down to raise or lower the sound, double-click a point to delete it. Saved with this clip.</p>
    </div>
  );
};
